import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { PermissionHelper } from '../helpers/permission.helper';
import { MpsUserService } from '../../../mps/services/mps-user.service';
import { User } from '../../models/user.model';

/**
 * Helper function to create a generic role guard with specified allowed roles
 * @param allowedRoles Array of role codes that are allowed to access the route
 * @returns An object with canActivate and canMatch guard functions
 */
export function createRoleGuard(allowedRoles: string[]) {
  const hasPermission = (): boolean | UrlTree => {
    const userService = inject(MpsUserService);
    const router = inject(Router);

    const mpsUser = userService.getUserSubject().getValue();
    if (!mpsUser) {
      return router.createUrlTree(['/']);
    }
    const authUser = new User(mpsUser);

    const isUserRoleAllowedForRoute = PermissionHelper.hasAnyRole(authUser, allowedRoles);
    return isUserRoleAllowedForRoute ? true : router.createUrlTree(['/']);
  };

  const canActivate: CanActivateFn = () => hasPermission();
  const canMatch: CanMatchFn = () => hasPermission();

  return { canActivate, canMatch };
}
